import { render, staticRenderFns } from "./calyrafit-review.vue?vue&type=template&id=54e6aa17&scoped=true&"
import script from "./calyrafit-review.vue?vue&type=script&lang=js&"
export * from "./calyrafit-review.vue?vue&type=script&lang=js&"
import style0 from "./calyrafit-review.vue?vue&type=style&index=0&id=54e6aa17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e6aa17",
  null
  
)

export default component.exports